// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Rt2n","toggle":"styles_toggle__2lZNC","preview":"styles_preview__3GdpT"};